import { render } from "./DbDeletePropsCmp.vue?vue&type=template&id=06104b10"
import script from "./DbDeletePropsCmp.vue?vue&type=script&lang=js"
export * from "./DbDeletePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__